export class ToolsRoutingConstants {
    static REPORT_ROUTE = "report";
    static REPORT_SCHEDULE_ROUTE = "report-schedule";
    static VIEWMAP_ROUTE = "esri-map";
    static UPGRADE_WORKFLOW_ROUTE = "upgrade-workflow";
}
